module.exports = __webpack_public_path__ + "img/05.dc94756a.png";